import { useEffect, useRef } from 'react';
import uiStore from 'shared/store/uiStore';

const useToggleMenu = () => {
  const menuVisible = uiStore((state) => state.menuVisible);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const toggleMenu = () => {
    if (menuVisible) {
      // Begin closing animation
      uiStore.getState().startMenuClosing();

      // Set timeout to actually hide the menu after animation completes
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        uiStore.getState().hideMenu();
      }, 300); // Match animation duration (300ms)
    } else {
      // Open the menu
      uiStore.getState().showMenu();
    }
  };

  // Clean up timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return toggleMenu;
};

export default useToggleMenu;
